"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  valueTypeRegistry: true,
  vals: true
};
exports.valueTypeRegistry = exports.vals = void 0;
var _ValueTypeRegistry = require("./ValueTypeRegistry");
var _ContractValueTypeHandler = require("./type/ContractValueTypeHandler");
Object.keys(_ContractValueTypeHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ContractValueTypeHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContractValueTypeHandler[key];
    }
  });
});
var _ErrorValueTypeHandler = require("./type/ErrorValueTypeHandler");
Object.keys(_ErrorValueTypeHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ErrorValueTypeHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorValueTypeHandler[key];
    }
  });
});
var _NftValueTypeHandler = require("./type/NftValueTypeHandler");
Object.keys(_NftValueTypeHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _NftValueTypeHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NftValueTypeHandler[key];
    }
  });
});
var _NullValueTypeHandler = require("./type/NullValueTypeHandler");
Object.keys(_NullValueTypeHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _NullValueTypeHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NullValueTypeHandler[key];
    }
  });
});
var _VarsValueTypeHandler = require("./type/VarsValueTypeHandler");
Object.keys(_VarsValueTypeHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _VarsValueTypeHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _VarsValueTypeHandler[key];
    }
  });
});
var _WalletValueTypeHandler = require("./type/WalletValueTypeHandler");
Object.keys(_WalletValueTypeHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WalletValueTypeHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WalletValueTypeHandler[key];
    }
  });
});
var _util = require("@blockwell/util");
const valueTypeRegistry = exports.valueTypeRegistry = new _ValueTypeRegistry.ValueTypeRegistry().register(new _ContractValueTypeHandler.ContractValueTypeHandler()).register(new _ErrorValueTypeHandler.ErrorValueTypeHandler()).register(new _NftValueTypeHandler.NftValueTypeHandler()).register(new _NullValueTypeHandler.NullValueTypeHandler()).register(new _VarsValueTypeHandler.VarsValueTypeHandler()).register(new _WalletValueTypeHandler.WalletValueTypeHandler());
const vals = exports.vals = {
  handler(val) {
    if (val !== null && val !== void 0 && val.type) {
      return valueTypeRegistry.get(val.type);
    }
    return null;
  },
  value(val) {
    var _vals$handler;
    return (_vals$handler = vals.handler(val)) === null || _vals$handler === void 0 ? void 0 : _vals$handler.value(val);
  },
  path(val, path) {
    const handler = vals.handler(val);
    if (handler.readPath) {
      if ((path === null || path === void 0 ? void 0 : path.length) > 0) {
        return {
          type: "value",
          value: handler.readPath(val, path)
        };
      }
    }
    return val;
  },
  truthy(val) {
    var _vals$handler2, _vals$handler2$truthy;
    return (_vals$handler2 = vals.handler(val)) === null || _vals$handler2 === void 0 ? void 0 : (_vals$handler2$truthy = _vals$handler2.truthy) === null || _vals$handler2$truthy === void 0 ? void 0 : _vals$handler2$truthy.call(_vals$handler2, val);
  },
  stringValue(val) {
    var _handler$stringValue;
    const handler = vals.handler(val);
    const value = handler === null || handler === void 0 ? void 0 : (_handler$stringValue = handler.stringValue) === null || _handler$stringValue === void 0 ? void 0 : _handler$stringValue.call(handler, val);
    return value;
  },
  numeric(val) {
    var _vals$handler3, _vals$handler3$numeri;
    let res = (_vals$handler3 = vals.handler(val)) === null || _vals$handler3 === void 0 ? void 0 : (_vals$handler3$numeri = _vals$handler3.numeric) === null || _vals$handler3$numeri === void 0 ? void 0 : _vals$handler3$numeri.call(_vals$handler3, val);
    if (res && !Array.isArray(res)) {
      return res.toNumber();
    }
    return null;
  },
  templateValue(val) {
    const handler = vals.handler(val);
    if (handler !== null && handler !== void 0 && handler.templateValue) {
      return handler.templateValue(val);
    }
    return handler === null || handler === void 0 ? void 0 : handler.value(val);
  },
  address(val) {
    var _vals$handler4, _vals$handler4$addres;
    return (_vals$handler4 = vals.handler(val)) === null || _vals$handler4 === void 0 ? void 0 : (_vals$handler4$addres = _vals$handler4.address) === null || _vals$handler4$addres === void 0 ? void 0 : _vals$handler4$addres.call(_vals$handler4, val);
  },
  meta(val, key) {
    var _vals$handler5, _vals$handler5$meta;
    return (_vals$handler5 = vals.handler(val)) === null || _vals$handler5 === void 0 ? void 0 : (_vals$handler5$meta = _vals$handler5.meta) === null || _vals$handler5$meta === void 0 ? void 0 : _vals$handler5$meta.call(_vals$handler5, val, key);
  },
  isMeta(val) {
    return (val === null || val === void 0 ? void 0 : val.type) === "value" && (0, _VarsValueTypeHandler.isVarsMetaValue)(val.value);
  },
  metaType(val) {
    return val.value[_VarsValueTypeHandler.VarsMetaSymbol];
  },
  array(val) {
    let value = vals.value(val);
    if (Array.isArray(value)) {
      return value;
    }
    return [];
  },
  stringArray(val) {
    let value = vals.value(val);
    if ((0, _util.isStrings)(value)) {
      return value;
    }
    return [];
  }
};
//# sourceMappingURL=types.js.map